module.exports = __webpack_public_path__ + "img/f5.f3b79f87.svg";